<nz-modal
  [nzVisible]="true"
  [nzFooter]="null"
  nzTitle="{{ i18n.langString('scan_popup_title') }}"
  (nzOnCancel)="popupClosed.emit()"
  [nzCloseIcon]="closeIcon"
  [nzContent]="modalContent"
>
  <ng-template #closeIcon>
    <img [alt]="'exitImg'" src="assets/icons/exit_new.svg" />
  </ng-template>

  <ng-template #modalContent>
    <div class="card-layer" [class.mobile]="isMobile()">
      <div class="buttonwrapper">
        <app-nav-button
          [primary]="true"
          [svgIcon]="'icons:scan-qr'"
          (clickEvent)="scanClicked.emit()"
          >{{ i18n.langString("scan_the_code") }}</app-nav-button
        >
        <app-nav-button
          [primary]="true"
          [svgIcon]="'icons:upload'"
          (clickEvent)="uploadClicked.emit()"
          >{{ i18n.langString("upload_the_code") }}</app-nav-button
        >
      </div>
    </div>
  </ng-template>
</nz-modal>
